import { Button, Container, Group, Stack, Text, Title } from "@mantine/core";
import { IconArrowLeft, IconHome, IconSearch } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <Container size="lg" className="not-found-container">
        <div className="not-found-content">
          {/* Animated 404 Number */}
          <div className="error-number">
            <span className="digit">4</span>
            <span className="digit">0</span>
            <span className="digit">4</span>
          </div>

          {/* Main Content */}
          <Stack gap="xl" align="center" className="main-content">
            <Title order={1} className="title">
              Oops! Page Not Found
            </Title>

            <Text className="description" size="lg" ta="center">
              The page you're looking for seems to have wandered off into the
              digital wilderness. Don't worry, even the best explorers get lost
              sometimes!
            </Text>

            {/* Action Buttons */}
            <Group gap="md" className="action-buttons">
              <Button
                leftSection={<IconArrowLeft size={16} />}
                variant="filled"
                size="lg"
                onClick={() => navigate("/d")}
                className="back-button"
              >
                Go Home
              </Button>
            </Group>
          </Stack>

          {/* Decorative Elements */}
          <div className="floating-elements">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
            <div className="floating-square square-1"></div>
            <div className="floating-square square-2"></div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound;
